module.exports = __webpack_public_path__ + "media/09 chord.e58c9dc3.mp3";